var exports = {
  "W": "xf61da738--fb18b6--labels",
  "F": "xf61da738--fb18b6--visited",
};

module.exports = exports;
